export default "__VITE_ASSET__Buojekjr__"